module.exports = __webpack_public_path__ + "static/media/miriam-godoy.f46efbe7.jpg";